import { connect } from 'react-redux';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import Counts from '../components/Counts';
import './Widget.scss';

class WidgetContainer extends React.Component {
	render() {
		return (
			<Common
				render={({ prefs, labels, sitemap, counts }) => {
					return (
						<Counts
							prefs={prefs}
							labels={labels}
							sitemap={sitemap}
							counts={counts}
						/>
					);
				}}
			/>
		);
	}
}

WidgetContainer.defaultProps = {};

WidgetContainer.propTypes = {};

const mapStateToProps = (_state) => {
	return {};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
